import Icon from '../Icon';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setLoginModalOpen } from '../../Actions/Login.action';
import styled from 'styled-components';
import { translate } from '../../Services/translation';
import { RootState } from '../../reducers';
import IconText from './IconText';
import MobileFooterMenuIconWrapper from './MobileFooterMenuIconWrapper';
import { toggleInputActive } from '../../Actions/QuickSearch.action';
import { toggleMobileMenu } from '../../Actions/Navigation.action';
import { setShowMiniCart } from '../../Actions/Cart.action';


const StyledLoginIcon = styled(Icon)`
  cursor: pointer;
`;

const LoginModalTriggerMobile = () => {

  const dispatch = useDispatch();
  const { modalOpen } = useSelector((state: RootState) => state.login);
  return (
    <MobileFooterMenuIconWrapper
      aria-label={translate('general.login')}
      title={translate('general.login')}
      onClick={() => {
        dispatch(setLoginModalOpen(!modalOpen))
        dispatch(toggleInputActive(false))
        dispatch(toggleMobileMenu(false))
        dispatch(setShowMiniCart(false))
      }}
    >
      <StyledLoginIcon name="user" className="icon--larger" />
      <IconText translationKey="general.login" />
    </MobileFooterMenuIconWrapper>
  );
};
export default LoginModalTriggerMobile;
